import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CommonService } from '../services/common.service';
import { IgnoreUrlPost, IgnoreUrlPut, IgnoreUrlDelete } from '../functions/ignore-url-toast.function';

/**
 * This interceptor use for user authentication and permissions.
 */
@Injectable({
  providedIn: 'root'
})
export class SnackarInterceptor implements HttpInterceptor {

  constructor(
    private commonService: CommonService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    let errorReq = false;
    if ((req.method === 'POST' ||
      req.method === 'PUT' ||
      req.method === 'DELETE') &&
      this.commonService.isIgnoreUrlForLoading(req)
    ) {
      this.commonService.changeStateLodding(true);
    }
    return next.handle(req).pipe(
      catchError((error, caught) => {
        errorReq = true;

        if ((error.error && error.error.message && error.error.message.includes('jwt'))) {
          this.commonService.showErrorSnackBar('شما زمان زیادی از سامانه استفاده نکردید.لطفا دوباره وارد شوید');
          this.commonService.logOut();
        } else {
          if (error.message.includes('Unknown Error')) {
            this.commonService.showErrorSnackBar('خطا در برقراری ارتباط با سرور لطفا دقایقی دیگر مجددا تلاش کنید');
          } else {
            this.commonService.showErrorSnackBar(error.error.message || error.message);
          }
        }

        return throwError(error);
      }),
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.commonService.changeStateLodding(false);
          if (req.method === 'POST' &&
            !errorReq &&
            IgnoreUrlPost(req)) {
            this.commonService.showSnackBar(event.body.message || 'با موفقیت ثبت شد!');
          }
          if (req.method === 'PUT' &&
            IgnoreUrlPut(req) && !errorReq) {

            this.commonService.showSnackBar(event.body.message || 'با موفقیت ویرایش شد!');
          }
          if (req.method === 'DELETE' && !errorReq &&
            IgnoreUrlDelete(req)) {
            this.commonService.showSnackBar(event.body.message || 'با موفقیت حذف شد!');
          }
        }
      })
    );
  }
}
